import {createRouter, createWebHashHistory} from 'vue-router'
import Home from '@/pages/Home.vue'
import FabricationCarte from '@/pages/FabricationCarte.vue'
import Erreur from '@/pages/Erreur.vue'
import Error404 from '@/pages/Error404.vue'
import Rechargement from '@/pages/Rechargement.vue'
import SuccesRechargement from '@/pages/SuccesRechargement.vue'
import SuccesAchatNFC from '@/pages/SuccesAchatNFC.vue'
import SuccesAchatQRCode from '@/pages/SuccesAchatQRCode.vue'
import Paiement from '@/pages/Paiement.vue'
import SuccesFabricationCarte from '@/pages/SuccesFabricationCarte.vue'
import Contact from '@/pages/Contact.vue'
import SuccesContact from '@/pages/SuccesContact.vue'
import GestionCookies from '@/pages/GestionCookies.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/fabrication-carte',
    name: 'fabrication_carte',
    component: FabricationCarte
  },
  {
    path: '/succes-fabrication-carte',
    name: 'succesfabrication_carte',
    component: SuccesFabricationCarte
  },
  {
    path: '/succes-achat-qrcode',
    name: 'succesAchatQRCode',
    component: SuccesAchatQRCode,
    props: true
  },
  {
    path: '/succes-achat-NFC',
    name: 'succesAchatNFC',
    component: SuccesAchatNFC,
  },
  {
    path: '/succes-contact',
    name: 'SuccesContact',
    component: SuccesContact,
  },
  {
    path: '/erreur',
    name: 'erreur',
    component: Erreur
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'error',
    component: Error404
  },
  {
    path: '/rechargement/:rechargementId?',
    name: 'rechargement',
    component: Rechargement
  },
  {
    path: '/succes-rechargement',
    name: 'succesRechargement',
    component: SuccesRechargement,
  },
  {
    path: '/paiement/:paylineToken',
    name: 'paiement',
    component: Paiement,
    props: true
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact
  },
  {
    path: '/gestion-cookies',
    name: 'gestionCookies',
    component: GestionCookies
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes: routes
})

router.afterEach((to) => {
  window._paq.push([
    'setCustomUrl',
    'https://isimouv.nuamouv.com/billetterie/#' + to.fullPath,
  ])
  window._paq.push(['trackPageView'])
})

export default router
